export default __webpack_public_path__ + "5ccc3670abdfbadd3f4c72b5989aea3d.mp3";